"use client";

import { ChartOptions } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { chartJsGridColor, chartJsTextColor } from "@portal/helpers/chartJs";

interface Props {
  isDefaultLanguage: boolean;
}

/**
 * Chart.js version of the planning page best/worst period column chart.
 * @param interface
 * @returns a chart.
 */
export const PlanningPageChart = ({ isDefaultLanguage }: Props) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { stacked: true, ticks: { color: chartJsTextColor() }, grid: { display: false } },
      y: {
        stacked: true,
        ticks: { display: false },
        border: { display: false },
        grid: { display: true, color: ctx => (ctx.index % 2 === 0 ? chartJsGridColor() : "transparent") },
      },
    },
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: texts.PAGE_4_CHART_HISTORIC,
        color: chartJsTextColor(),
        font: { size: 16 },
      },
      tooltip: {
        callbacks: { label: item => `${item.dataset.label}: ${(item.raw as number).toFixed(2)}%` },
      },
      datalabels: {
        color: chartJsTextColor(),
        anchor: ctx => ((ctx.dataset.data[ctx.dataIndex] as number) >= 0 ? "end" : "start"),
        align: ctx => ((ctx.dataset.data[ctx.dataIndex] as number) >= 0 ? "top" : "bottom"),
        formatter: (value: number) => `${value} %`,
      },
    },
  };

  return (
    <div className="flex-1 min-h-80">
      <Bar
        data={{
          labels: [texts.PAGE_4_DATA_ONE, texts.PAGE_4_DATA_FIVE, texts.PAGE_4_DATA_TEN],
          datasets: [
            { label: texts.PAGE_4_CHART_BEST_PERIOD, data: [45, 24, 13], backgroundColor: "#e0a507" },
            { label: texts.PAGE_4_CHART_WORST_PERIOD, data: [-42, -6, -3], backgroundColor: "#02304b" },
          ],
        }}
        options={options}
        plugins={[ChartDataLabels]}
      />
    </div>
  );
};
